<template>
  <div v-if="!isTaiwan" :data-tips="t('headerTools.shop')" class="header-comps-shop">
   <icon type="mall" size="22" />
  </div>
</template>

<script>
import icon from '../icon';
import i18nHandle from '../../locales';

export default {
  components: {
    Icon: icon,
  },
  methods: {
    t: i18nHandle.t,
  },
  computed: {
    isTaiwan() {
      return window.location.host.includes('okki.com');
    },
  },
};
</script>

<style lang="scss">
.header-comps-shop {
  position: relative;

   &::after {
    content: attr(data-tips);
    white-space: nowrap;
    position: absolute;
    top: 100%;
    left: 50%;
    padding: 3px 5px;
    margin-top: 3px;
    color:#fff;
    font-size:12px;
    background:#5b5b5b;
    border-radius: 3px;
    transform: translateX(-50%);
    display: none;
   }

   &:hover {
     &::after {
       display: block;
     }
   }
}
</style>

-
